import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="font-heading text-2xl text-background-50 whitespace-nowrap">
              073漫画网
            </Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              在线免费阅读下拉式漫画，操作便捷、加载快速，追漫不受限制。洞洞杂货铺等热门漫画每日更新，支持手机电脑随时畅读。
            </p>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              <a href="/categories" className="hover:text-primary-400 transition-colors">漫画分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              <a href="/links" className="hover:text-primary-400 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="/privacy" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="/terms" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  服务条款
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              <a href="/contact" className="hover:text-primary-400 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@073mh.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-line text-primary-400"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>中国·湖南省</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 073漫画网 版权所有 | 洞洞杂货铺漫画在线免费阅读
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-primary-400 transition-colors" rel="nofollow" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-primary-400 transition-colors" rel="nofollow" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-primary-400 transition-colors" rel="nofollow" aria-label="QQ">
              <i className="ri-qq-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}